const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const tracking = require('od-modules/checkin/tracking');
const {isRefundInProgress} = require('od-modules/checkin/refund.status');

const HIDDEN_CLASS = 'odf-hidden';

module.exports = withCachedSelectors(BaseView.extend({
    events: {
        'change .checkin_error_show_more_input': 'handleClickShowMoreLess',
    },
    selectors: {
        checkinPopupErrorContainer: '.checkin_error_container',
        checkinErrorShowMoreInput: '.checkin_error_show_more_input',
    },

    initialize() {
        const hasSuspendedError = this.someSectionsHaveSuspendedError(this.options.checkinStatus);
        this.feedbackDescription = (hasSuspendedError ? this.keys.checkinMfFeedbackSuspendedDescription : this.keys.checkinMfFeedbackKoDescription);
        this.renderPromise = this.render();
    },

    async render() {
        const refundInProgress = await isRefundInProgress();
        this.el.innerHTML = refundInProgress ? this.templates.checkinPaid(this) : this.templates.main(this);
    },

    showCheckinError(show) {
        (this.renderPromise || Promise.resolve()).then(() => {
            this.$el.find(this.selectors.checkinPopupErrorContainer).toggleClass(HIDDEN_CLASS, !show);
            if (show) {
                this.trackCheckinErrorShow();
            }
        });
    },

    trackCheckinErrorShow(bookingData) {
        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        tracking.trackAutoCheckinFailed(bookingInfo);
    },

    handleClickShowMoreLess() {
        const action = this.$el.find(this.selectors.checkinErrorShowMoreInput).is(':checked') ? 'more': 'less';
        this.trackCheckinErrorShowMore(action);
    },

    trackCheckinErrorShowMore(action) {
        tracking.trackCheckinErrorShowMore(action);
    },

    someSectionsHaveSuspendedError(checkinStatus) {
        return Odigeo._.some(Odigeo._.get(checkinStatus, 'checkinInformation.sections'), (section) => {
            return section.status === 'SUSPENDED';
        });
    },
}));

